import React, { useEffect } from 'react';
import { useFindAllReasonMasterDisplayQuery } from 'reducers/masterData/reasonMaster/api';
import { goBack, push } from 'connected-react-router';
import { useSelector, useDispatch } from 'react-redux';
import { useErrorHandler } from 'common_components/ErrorContext';
import { PageHeader, Divider, Spin, Button } from 'antd';
import { LoadingOutlined, PlusCircleOutlined } from '@ant-design/icons';
import permission from 'permissions';
import { getCurrentUser } from 'reducers/user';
import styled from 'styled-components';
import Table from './Table';

const ReasonMasterListComponent = (props) => {
  const dispatch = useDispatch();
  const { data, error, isLoading, isFetching, refetch } =
    useFindAllReasonMasterDisplayQuery();
  const user = useSelector(getCurrentUser);
  const { setErrorData } = useErrorHandler();
  const refetchData = () => {
    refetch();
  };

  useEffect(() => {
    if (error) {
      setErrorData(error);
    }
  }, [error, setErrorData]);

  return (
    <Container>
      <StyledPageHeader
        ghost={false}
        onBack={() => dispatch(goBack())}
        title='Reason Master List'
        subTitle=''
        extra={
          <>
            {permission.checkPermission(user, 'reason_master', ['c']) ? (
              <>
                <Button
                  icon={<PlusCircleOutlined />}
                  key='group_reasons'
                  type='primary'
                  onClick={() => {
                    dispatch(push('/app/master/group_reasons/create'));
                  }}
                >
                  Groups
                </Button>
                <Button
                  icon={<PlusCircleOutlined />}
                  key='subject_reasons'
                  type='primary'
                  onClick={() => {
                    dispatch(push('/app/master/subject_reasons/create'));
                  }}
                >
                  Subject Reason
                </Button>
              </>
            ) : null}
          </>
        }
      />
      <Divider style={{ margin: 0 }} />
      <Content>
        {isLoading === true ? (
          <RootCircular>
            <CenterSpin indicator={antIcon} size='large' />
          </RootCircular>
        ) : (
          <Table
            rowDataDisplay={data}
            refetchData={refetchData}
            isLoading={isFetching}
          />
        )}
      </Content>
    </Container>
  );
};

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const StyledPageHeader = styled(PageHeader)`
  padding: 0px 10px;
`;

const Container = styled.div`
  height: calc(100%);
  padding: 10px;
`;

const Content = styled.div`
  background: white;
  height: calc(100% - 42px);
  overflow: auto;
`;

const RootCircular = styled.div`
  display: table;
  height: calc(100%);
  margin: auto;
`;

const CenterSpin = styled(Spin)`
  display: table-cell;
  vertical-align: middle;
`;

export default ReasonMasterListComponent;
